// src/hooks/useCurrencyCode.js
import { useEffect, useState } from 'react';
import { DEFAULT_CURRENCY } from '../utils/currency';
import { loadSettings } from '../utils/posSettings';

/**
 * React hook that exposes the active currency code stored in POS settings.
 * It listens for the custom `pos-settings-changed` event so any updates made
 * elsewhere in the UI (e.g. the Settings page) are reflected instantly.
 */
export default function useCurrencyCode() {
  const [currencyCode, setCurrencyCode] = useState(DEFAULT_CURRENCY);

  useEffect(() => {
    const applySettings = () => {
      try {
        if (typeof window === 'undefined') {
          setCurrencyCode(DEFAULT_CURRENCY);
          return;
        }
        const settings = loadSettings();
        setCurrencyCode(settings.currencyCode || DEFAULT_CURRENCY);
      } catch {
        setCurrencyCode(DEFAULT_CURRENCY);
      }
    };

    applySettings();
    window.addEventListener('pos-settings-changed', applySettings);
    return () => {
      window.removeEventListener('pos-settings-changed', applySettings);
    };
  }, []);

  return currencyCode;
}
